/* eslint-disable no-useless-escape */
import React, {useState, useEffect} from  'react';
import  {NavLink, withRouter} from 'react-router-dom';
import withAuthLayout from 'components/layouts/withAuthLayout';
import {ReactComponent as Logo } from  'assets/images/svg/logo.svg';
import { authenticateUser, isAuthenticated } from 'libs/helpers';
import { Formik } from 'formik';
import Swal from 'sweetalert2'

const LoginPage = props => {
    const {history} = props
    const [allRoles, setRoles] = useState([])
    const [isLoadingRoles, setIsLoadingRoles] = useState(false);

    useEffect(()=>{
        if(isAuthenticated()){
            
            history.push('/user/landing')
        }
    }, [history])

    useEffect(() => {
        setIsLoadingRoles(true)
        fetch('https://musicandrights.herokuapp.com/api/v1/roles')
        .then(res =>  res.json())
        .then( roles => {
            setIsLoadingRoles(false);
            setRoles(roles.data.roles);
        })
        .catch(err => {
            setIsLoadingRoles(false)
        })
    }, []);
    
    return (
        <div className="row">
            <div className="w-100">
                <div className="d-flex flex-row justify-content-center">
                    <Logo className="mx-auto"/>
                </div>
            </div>
            <div className="col-md-9 mx-auto">
                <div className="auth-login__main">
                    <h2 className="auth-login__main-header">Login in to Music & Rights</h2>
                    <p className="auth-login__main-info">We are excited to have to you back</p>
                    <Formik 
                        initialValues={{email: '', password: '', role_id: ''}}
                        validate={ (values) => {
                            // console.log(values)
                            let errors = {}
                            const regexp = new RegExp(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i);
                            if (!values.email ||  !regexp.test(values.email)){
                                errors.email = true
                            }
                            if(!values.password || values.password.length < 5) {
                                errors.password = true
                            }
                            if(!values.role_id || values.role_id === ''){
                                errors.role_id = true
                            }
                            return errors;
                        
                        }}
                        onSubmit={ (values, {isSubmitting,setSubmitting }) => {
                            // console.log()
                            setSubmitting(true)

                            fetch('https://musicandrights.herokuapp.com/api/v1/user/login',{
                                method: 'POST',
                                headers: {'Content-Type': 'application/json'},
                                body: JSON.stringify(values)
                            })
                            .then(res => res.json())
                            .then(res => {
                                setSubmitting(false)
                                // console.log(res)
                                if(res.code === 200){
                                    authenticateUser(res.token)
                                    // console.log(isAuthenticated())
                                    history.push('/user/landing')
                                }
                                if(res.code === 400 ){
                                    Swal.fire({
                                        type: 'error',
                                        title: 'Login failed',
                                        text: res.message
                                    })
                                }
                            })
                            .catch(err => {
                                setSubmitting(false)
                                // console.log(err)
                            })

                        }}>
                            {({
                                values,
                                errors,
                                touched,
                                handleChange,
                                handleBlur,
                                handleSubmit,
                                isSubmitting,
                                setSubmitting
                                /* and other goodies */
                                }) => (
                                    <form className="nsForm" onSubmit={handleSubmit}>
                                        <div>
                                            <label className="nsForm-label">email address</label>
                                            <input name="email" className={`nsForm-input ${ touched.email && errors.email ? 'error' : ''}`} type="email" placeholder="Enter your Email address" onChange={handleChange}/>
                                        </div>
                                        <div>
                                            <label className="nsForm-label">password</label>
                                            <input name="password" className={`nsForm-input ${ touched.password && errors.password ? 'error' : ''}`} type="password" placeholder="* * * * * * *" onChange={handleChange}/>
                                        </div>
                                        <div>
                                            <label className="nsForm-label">role</label>
                                            <div className={`nsForm-select`}>
                                                <select name="role_id" onChange={handleChange} className={`${touched.role_id && errors.role_id ? 'error': ''}`}>
                                                    <option value="">{ isLoadingRoles ? 'Loading Roles ...' : 'Select Role'}</option>
                                                    {
                                                        allRoles && allRoles.map( (role, index) => (
                                                            <option key={index} value={role.id}>{role.name}</option>
                                                        ))
                                                    }
                                                </select>

                                            </div>
                                        </div>

                                        <div className="d-flex flex-row justify-content-between my-3">
                                            <div className="d-flex flex-row">
                                                <input type="checkbox" className="mr-2"/>
                                                <p className="text--small text--grey ml-1">Remember Me</p>
                                            </div>
                                            <p className="text--small text--grey"><NavLink to="/forgot-password">Forgot Password ?</NavLink></p>
                                        </div>

                                        <button type="submit" className={`pill ${isSubmitting ? 'pill--secondary' : 'pill--grey'}`} disabled={isSubmitting} >
                                            <p>{ isSubmitting ? 'Logging ...' : 'Login'}</p>
                                        </button>
                                    </form>
                                )}
                    </Formik>
                    
                </div>

                <div className="auth-bottom">
                    <div className="auth__last-button pill pill--whitesmoke">
                        <p>Don't have an account? <NavLink to="/register" className="auth__link">Sign up</NavLink>.</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default withAuthLayout(withRouter(LoginPage), {});